import { FC, useEffect, useState } from 'react';
import { Column } from 'primereact/column';
import UsersFilters from 'components/users/UsersFilters';
import { observer } from 'mobx-react';
import accountsStore from 'store/AccountsStore';
import commonStore from 'store/CommonStore';
import { Paginator, PaginatorPageState } from 'primereact/paginator';
import { AccountsFilters } from 'types';
import {
  CreatedAtBodyTemplate,
  IsDeletedBodyTemplate,
  IsEmailConfirmedBodyTemplate,
  LastActivityTimeBodyTemplate,
  RoleBodyTemplate,
  EmiasLinkedBodyTemplate,
  LastMeasurementSyncDateBodyTemplate,
  EmailBodyTemplate,
} from 'components/users/UsersColumnsBodyTemplates';
import { DataTable } from 'components/base/DataTable';
import Spinner from 'components/base/spinner';
import styled from 'styled-components';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const UsersRootPage: FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [rows, setRows] = useState<number>(1);
  const [filters, setFilters] = useState<AccountsFilters>({});

  useEffect(() => {
    accountsStore.fetchAccounts({ page: 1, size: 10 });
    commonStore.fetchAccountRoles();
  }, []);

  const handlePageChange = (event: PaginatorPageState) => {
    setCurrentPage(event.page);
    setRows(event.rows);
    accountsStore.fetchAccounts({
      page: event.page + 1,
      size: 10,
      ...filters,
    });
  };

  return (
    <>
      <h1 className="mb-5">Пользователи</h1>
      <UsersFilters
        setCurrentPage={setCurrentPage}
        setRows={setRows}
        filters={filters}
        setFilters={setFilters}
      />
      {accountsStore.state === 'done' ? (
        <>
          <TableWrapper>
            <DataTable
              value={accountsStore.accounts}
              rows={10}
              responsiveLayout="stack"
            >
              <Column
                field="email"
                header="Email пользователя"
                body={EmailBodyTemplate}
              />
              <Column
                field="roles"
                header="Роль"
                body={RoleBodyTemplate}
              />
              <Column
                field="isDeleted"
                header="Состояние учетной записи"
                body={IsDeletedBodyTemplate}
              />
              <Column
                field="createdAt"
                header="Дата создания учетной записи"
                body={CreatedAtBodyTemplate}
              />
              <Column
                field="lastActivityTime"
                header="Дата последнего запуска приложения"
                body={LastActivityTimeBodyTemplate}
              />
              <Column
                field="isEmailConfirmed"
                header="Почта подтверждена"
                body={IsEmailConfirmedBodyTemplate}
              />
              <Column
                field="emiasLinked"
                header="Привязка к ЕМИАС"
                body={EmiasLinkedBodyTemplate}
              />
              <Column
                field="lastMeasurementSyncDate"
                header="Дата последнего успешного отправленного измерения в ЕМИАС"
                body={LastMeasurementSyncDateBodyTemplate}
              />
              {/* <Column
           headerStyle={{ width: '4rem', textAlign: 'center' }}
           bodyStyle={{ textAlign: 'center' }}
           body={ActionBodyTemplate}
         /> */}
            </DataTable>
          </TableWrapper>
          <Paginator
            rows={rows}
            first={currentPage * rows}
            totalRecords={accountsStore.totalPages}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default observer(UsersRootPage);
